import React from 'react';
import { connect } from 'react-redux';
import MultiCurrency from './multi-currency';

class MultiCurrencyContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { amountInSek, preferredCurrency } = this.props;
        return (
            <MultiCurrency
                amountInSek={amountInSek}
                preferredCurrency={preferredCurrency}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        preferredCurrency: state.multiCurrency.preferredCurrency,
        ...ownProps
    };
};

export default connect(mapStateToProps)(MultiCurrencyContainer);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/multi-currency/multi-currency-container.jsx